export default "__VITE_ASSET__3df68a69__"